/** Stable Find values sent to mapFindToApi via the weekly pulse API. */
export const TERMINAL_PULSE_FIND_ALL = 'all';
export const TERMINAL_PULSE_FIND_HIGH = 'high';
export const TERMINAL_PULSE_FIND_LOW = 'low';

export const TERMINAL_PULSE_FIND_OPTIONS = [
  { value: TERMINAL_PULSE_FIND_ALL, labelKey: 'filters.allPrices' },
  { value: TERMINAL_PULSE_FIND_HIGH, labelKey: 'filters.highPrice' },
  { value: TERMINAL_PULSE_FIND_LOW, labelKey: 'filters.lowPrice' },
];
